import styles from '../../styles/PageLoader.module.css';

export const PageLoader = () => (
    <div className={styles.loader}>
        <div className={styles.spinner} aria-hidden="true" />
    </div>
);